var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3352 9.55048L8.91593 17.8154L1.4967 9.55048C1.00734 9.01486 0.621869 8.37107 0.364575 7.65966C0.107282 6.94824 -0.0162649 6.18461 0.0017152 5.41685C0.0196953 4.64909 0.178813 3.89383 0.469048 3.19864C0.759283 2.50344 1.17435 1.88337 1.68811 1.37747C2.20186 0.871567 2.80319 0.490794 3.4542 0.259127C4.10522 0.0274609 4.79184 -0.0500799 5.47081 0.0313869C6.14978 0.112854 6.8064 0.351563 7.39932 0.732485C7.99224 1.11341 8.50862 1.62829 8.91593 2.2447C9.32502 1.63276 9.84199 1.12238 10.4345 0.745501C11.027 0.368622 11.6823 0.133361 12.3594 0.0544398C13.0364 -0.0244811 13.7207 0.0546379 14.3693 0.286845C15.018 0.519052 15.617 0.899348 16.129 1.40393C16.6409 1.90852 17.0548 2.52653 17.3446 3.21928C17.6344 3.91204 17.794 4.66463 17.8134 5.42995C17.8327 6.19527 17.7114 6.95685 17.4571 7.66702C17.2027 8.37718 16.8208 9.02066 16.3352 9.55716",
    fill: "#FD6771"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavBtn);
export default __webpack_public_path__ + "static/media/favBtn.85c6013db53349423028e2eb730b12a5.svg";
export { ForwardRef as ReactComponent };